import React, {useState, useEffect, useRef} from 'react';
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Dropdown} from "primereact/dropdown";
import {ProgressBar} from 'primereact/progressbar';
import axios from "axios";
import { Tag } from 'primereact/tag';
import {Dialog} from 'primereact/dialog';

import ProductionMetricsMeasuresSummary from "../productionmetricsmeasuressummary/ProductionMetricsMeasuresSummary";
// import ProductionWorkflowMetricsForm from "../productionmetricsmeasuressummary/ProductionWorkflowMetricsForm";

import KanbanComponent from "../kanbanview/KanbanComponent";
import ProjectItemSummaryCard from "./ProjectItemSummaryCard";

const ProductionjobListComponent = (props) => {

  const {t, productionItemId, projectItemId, view, editableStatus = false} = props;
  const [productionjobs, setProductionjobs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const [productionStatus, setProductionStatus] = useState([]);
  const [statusUpdatingId, setStatusUpdatingId] = useState(null);
  const [dialogVisible, setDialogVisible] = useState(false);
  const [dialogLoading, setDialogLoading] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);
  const [selectedJobProjectItemId, setSelectedJobProjectItemId] = useState(null);
  const [selectedProjectItem, setSelectedProjectItem] = useState(null);
  const dt = useRef(null);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      const baseQuery = window.App.transformQueryParams(lazyParams) || '';
      const sp = new URLSearchParams(baseQuery.startsWith('?') ? baseQuery.slice(1) : baseQuery);

      if (productionItemId) {
        sp.set('search[production_item][operator]', '=');
        sp.set('search[production_item][value]', productionItemId);
      }
      if (projectItemId) {
        sp.set('search[project_item][operator]', '=');
        sp.set('search[project_item][value]', projectItemId);
      }

      const query = sp.toString() ? `?${sp.toString()}` : '';
      apiCall('get', '/api/v2/production-job' + query)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setProductionjobs(response.data.data.items)
          props?.onLoaded?.(response.data.data.items[0] || {});
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const getProjectItemIdFromJob = (job) => {
    return (
      job?.project_item?.id ||
      job?.project_item ||
      job?.project_item_id ||
      job?.production_item?.project_item?.id ||
      job?.production_item?.project_item ||
      null
    );
  };

  const getProductionItemIdFromJob = (job) => {
    return (
      job?.production_item?.id ||
      job?.production_item_id ||
      null
    );
  };

  const getProjectItemIdFromProductionItem = (productionItem) => {
    return (
      productionItem?.project_item?.id ||
      productionItem?.project_item ||
      productionItem?.project_item_id ||
      productionItem?.projectItem?.id ||
      productionItem?.projectItemId ||
      null
    );
  };

  const loadProductionJob = (jobId) => {

    if (!jobId) return;

    setDialogVisible(true);
    setDialogLoading(true);
    setSelectedJob(null);
    setSelectedJobProjectItemId(null);
    setSelectedProjectItem(null);

    apiCall('get', '/api/v2/production-job/' + jobId)
      .then((response) => {
        const job = response?.data?.data || null;

        setSelectedJob(job);

        const directProjectItemId = getProjectItemIdFromJob(job);

        if (directProjectItemId) {
          setSelectedJobProjectItemId(directProjectItemId);
          return;
        }

        const productionItemId = getProductionItemIdFromJob(job);

        if (!productionItemId) {
          setSelectedJobProjectItemId(null);
          return;
        }

        apiCall('get', '/api/v2/production-item/' + productionItemId)
          .then((productionItemResponse) => {
            const productionItem = productionItemResponse?.data?.data || null;
            const projectItemId = getProjectItemIdFromProductionItem(productionItem);

            setSelectedJobProjectItemId(projectItemId);
          })
          .catch((error) => {
            window.App.toastShow('error', t('error'), error.toString(), '', error.response);
            setSelectedJobProjectItemId(null);
          });
      })
      .catch((error) => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        setSelectedJob(null);
        setSelectedJobProjectItemId(null);
      })
      .finally(() => {
        setDialogLoading(false);
      });
  };

  const updateProductionJobStatus = (job, newStatus) => {
    if (!job?.id || !newStatus || job.status === newStatus) {
      return;
    }
    setStatusUpdatingId(job.id);
    apiCall('patch', '/api/v2/production-job/' + job.id, {
      status: newStatus
    })
      .then(() => {
        window.App.toastShow('success', 'Sikeres módosítás!');
        setSelectedJob(prev =>
          prev?.id === job.id
            ? { ...prev, status: newStatus }
            : prev
        );
        setProductionjobs(prev =>
          prev.map(item =>
            item.id === job.id
              ? { ...item, status: newStatus }
              : item
          )
        );
        window.App.setState({
          rerenderProductionjobList: Math.random(),
          rerenderProjectitemList: Math.random(),
          rerenderProjectShow: Math.random(),
        });
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setStatusUpdatingId(null);
      });
  };

  const getProductionStatusSeverity = (status) => {
    const key = status ? status.toString().toUpperCase() : '';
    switch (key) {
      case 'NEW':
        return 'primary';
      case 'SCHEDULED':
        return 'secondary';
      case 'IN_PROGRESS':
        return 'info';
      case 'PAUSED':
      case 'SUSPENDED':
        return 'warning';
      case 'DONE':
        return 'success';
      case 'DELETED':
        return 'danger';
      default:
        return null;
    }
  };

  const getProductionStatusLabel = (status) => {
    if (!status) return '-';
    const key = status.toString().toUpperCase();
    const item = productionStatus.find((statusItem) => statusItem.key === key);
    return item?.value || key;
  };

  const selectableProductionStatusOptions = productionStatus.filter(
    (statusItem) => statusItem?.key !== 'SCHEDULED'
  );

  const renderProductionStatusBadge = (status, job = null) => {
    const currentStatus = status ? status.toString().toUpperCase() : null;
    const renderStatusOption = (option) => {
      if (!option) return null;
      return (
        <Tag
          value={option.value || option.key}
          severity={getProductionStatusSeverity(option.key)}
          rounded
        />
      );
    };
    if (!editableStatus || !job?.id) {
      return (
        <Tag
          value={getProductionStatusLabel(status)}
          severity={getProductionStatusSeverity(status)}
          rounded
        />
      );
    }
    return (
      <Dropdown
        value={currentStatus}
        options={selectableProductionStatusOptions}
        optionLabel="value"
        optionValue="key"
        itemTemplate={renderStatusOption}
        valueTemplate={renderStatusOption}
        appendTo={document.body}
        disabled={statusUpdatingId === job.id}
        onChange={(e) => updateProductionJobStatus(job, e.value)}
        className="p-inputtext-sm"
        style={{
          minWidth: '130px'
        }}
      />
    );
  };

  // const actionBodyTemplate = (rowData) => {
  //   return (
  //     <React.Fragment>
  //       {localStorage.getItem('roles').toString().includes('role_') &&
  //         <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
  //                 tooltip={t('edit')} tooltipOptions={{position: 'left'}}
  //                 onClick={() => {
  //                   if(entity === 'production-job') {
  //                     history.push('/production/production-job/update/' + rowData.id)
  //                   }
  //                 }}/>
  //       }
  //       {localStorage.getItem('roles').toString().includes('role_') &&
  //         <Button icon="pi pi-trash" className="p-button-danger"
  //                 tooltip={t('delete')} tooltipOptions={{position: 'left'}}
  //                 onClick={() => {
  //                   if (window.confirm('A törlés megerősítésére van szükség!')) {
  //                     setLoading(true);
  //                     apiCall('delete', '/api/v2/production-job/' + rowData.id)
  //                       .then(response => {
  //                         window.App.toastShow('success', 'Sikeres törlés!');
  //                         window.App.setState({rerenderProductionjobList: Math.random()})
  //                       })
  //                       .catch(error => {
  //                         window.App.toastShow('error', t('error'), error.toString(), '', error.response);
  //                       })
  //                       .finally(() => {
  //                         setLoading(false);
  //                       })
  //                   }
  //                 }}
  //         />
  //       }
  //     </React.Fragment>
  //   );
  // }

  useEffect(() => {
    apiCall('get', '/api/v2/dictionary/production-status')
      .then((response) => {
        setProductionStatus(response?.data?.data || []);
      })
      .catch((error) => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
  }, []);

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, productionItemId, projectItemId, view, window.App.state.rerenderProductionjobList])

  
  if (view === 'cards') {
    return (
      <div className="ProductionjobListComponent production-kanban-items">
        {loading && (
          <ProgressBar
            mode="indeterminate"
            style={{height: '5px', borderRadius: 0}}
          />
        )}

        {productionjobs.map((job) => (
          <KanbanComponent
            key={job.id}
            job={job}
            t={t}
            onView={(job) => loadProductionJob(job?.id)}
            renderStatusBadge={renderProductionStatusBadge}
            formatDateValue={window.App.formatDateValue}
          />
        ))}

        {!loading && productionjobs.length === 0 && (
          <div className="p-text-muted p-p-3">
            {t('noTask')}
          </div>
        )}

        <Dialog
          header={t('taskDetails')}
          visible={dialogVisible}
          style={{ width: '50vw' }}
          onHide={() => {
            setDialogVisible(false);
            setSelectedJob(null);
            setSelectedJobProjectItemId(null);
            setSelectedProjectItem(null);
          }}
        >
          {dialogLoading && (
            <ProgressBar mode="indeterminate" style={{ height: '5px' }} />
          )}

          {!dialogLoading && selectedJob && (
            <>
              <div className="p-grid">
                <div className="p-col-12 p-lg-6">
                  <KanbanComponent
                    job={selectedJob}
                    t={t}
                    renderStatusBadge={renderProductionStatusBadge}
                    formatDateValue={window.App.formatDateValue}
                    style={{ height: '100%' }}
                  />
                </div>

                {selectedProjectItem && (
                  <div className="p-col-12 p-lg-6">
                    <ProjectItemSummaryCard
                      projectItem={selectedProjectItem}
                      t={t}
                    />
                  </div>
                )}
              </div>

              <ProductionMetricsMeasuresSummary
                productionJobId={selectedJob?.id}
                t={t}
                title={t('productionDataRecordedForTask')}
                emptyMessage={t('noProductionDataRecordedForTask')}
                showProjectItemDetails={false}
              />

              <ProductionMetricsMeasuresSummary
                projectItemId={selectedJobProjectItemId}
                t={t}
                showProjectItemDetails={false}
                onProjectItemLoaded={setSelectedProjectItem}
              />

              {/* <ProductionWorkflowMetricsForm
                projectItemId={selectedJobProjectItemId}
                productionJobId={selectedJob?.id}
                t={t}
                onSaved={() => setMetricsRefreshKey((prev) => prev + 1)}
              /> */}
            </>
          )}
        </Dialog>
      </div>
    );
  }


  return (
    <>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={productionjobs} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 dataKey="id"
      >
        <Column field="technology.name" header={t('columnName')} sortable filter></Column>
        <Column field="project_number" header={t('columnProjectNumber')} sortable filter></Column>
        <Column header={t('columnQuantity')} sortable filter body={(rowData) => {
          return (
            <>
              {rowData.quantity ? rowData.quantity : ''} {rowData.unit?.name ? rowData.unit.name : ''}
            </>
          )
        }}></Column>


        <Column field="production_item.external_reference" header={t('externalReference')} sortable filter></Column>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(ProductionjobListComponent);
